import styled from '@emotion/styled'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'

import LogoCarouselTemplate from '@segment/templates/LogoCarousel'

const LogoCarousel = () => (
  <StyledSection variant="centered">
    <StyledLogoCarousel />
  </StyledSection>
)

const StyledSection = styled(SectionBase)`
  ${Section.Wrapper} {
    gap: 0;
    padding-bottom: 0;
  }
`

const StyledLogoCarousel = styled(LogoCarouselTemplate)`
  padding: 0;
`

export default LogoCarousel
